import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import SwitchItem from './switchItem';

const NotificationPanel = ({ hideTitle = false, onSwitchToggle, settings = [] }) => (
	<Fragment>
		<div className="flex margin-bottom-20">
			<div className="flex-3">
				<If condition={!hideTitle}>
					<span className="font-regular color-gray-mine-shaft font-size-16">Notifications</span>
				</If>
			</div>
			<div className="text-right flex-1">
				<span className="font-regular color-gray-mine-shaft font-size-16">Email</span>
			</div>
			<div className="text-right flex-1">
				<span className="font-regular color-gray-mine-shaft font-size-16">SMS</span>
			</div>
		</div>
		<For
			each="setting"
			index="index"
			of={settings}
		>
			<SwitchItem
				key={`${setting.GroupType}_${setting.GroupName}`}
				labelText={`${setting.GroupName} (${setting.GroupDescription})`}
				notificationMethods={setting.NotificationMethods}
				onChange={onSwitchToggle}
				property={index}
			/>
		</For>
	</Fragment>
);

NotificationPanel.propTypes = {
	hideTitle      : PropTypes.bool,
	onSwitchToggle : PropTypes.func.isRequired,
	settings       : PropTypes.array,
};

NotificationPanel.defaultProps = {
	hideTitle : false,
	settings  : [],
};

export default NotificationPanel;
